<template>
  <v-app>
    <template v-if="userLoaded">
      <!-- навигация -->
      <v-navigation-drawer v-if="navigationEnabled"
        :key="$store.getters['settings/compactMenu'] + $store.getters['settings/dark']" app permanent
        :expand-on-hover="$store.getters['settings/compactMenu']">
        <v-list>
          <v-list-item class="px-3">
            <Account />
          </v-list-item>
        </v-list>

        <v-divider />

        <v-list nav dense>
          <v-list-item-group>
            <template v-for="item in navigation">
              <!-- родительские элемент -->
              <v-list-item v-if="$router.isRouteAllowed(item.link)" :key="item.text" :to="item.link" link>
                <v-list-item-icon class="mr-4">
                  <v-icon v-if="item.icon" v-text="item.icon" />
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title v-text="item.text" />
                </v-list-item-content>
              </v-list-item>
            </template>
            <Reports />
            <Settings />
          </v-list-item-group>
        </v-list>
      </v-navigation-drawer>

      <!-- main -->
      <v-main class="mainBackground" :style="mainStyles">
        <router-view />
      </v-main>
    </template>
    <Notify />
    <MessageBox />
  </v-app>
</template>

<script>
import Account from "@/components/Account"
import Notify from "@/components/Notify"
import MessageBox from "@/components/MessageBox"
import Reports from "@/reports/Reports"
import Settings from "@/components/Settings"

export default {
  components: {
    Account,
    Notify,
    MessageBox,
    Reports,
    Settings
  },

  data: () => ({
    navigation: [
      { link: "/carQueue", text: "Регистрация машин", icon: "mdi-truck-delivery-outline" },
      { link: "/carRequests", text: "Текущая ситуация", icon: "mdi-list-status" },
      { link: "/goods", text: "Товары", icon: "mdi-package-variant" },
      { link: "/requests", text: "Заявки", icon: "mdi-file-document-outline" },
      { link: "/users", text: "Пользователи", icon: "mdi-account-lock-outline" },
    ]
  }),

  computed: {
    userLoaded() {
      return this.$store.state.auth.userLoaded
    },

    navigationEnabled: {
      get() {
        const user = this.$store.state.auth.user
        return user ? user.role !== "Регистратор" : false
      }
    },

    compactMenu() {
      return this.$store.getters['settings/compactMenu']
    },

    mainStyles() {
      return {
        padding: this.compactMenu
          ? '0px 0px 0px 56px'
          : '0px 0px 0px 256px'
      }
    }
  }
}
</script>